import USServiceModel from "./USServiceModel";
import { UD_X_CLIENT } from "../Common/constants";

export default abstract class AuthModel extends USServiceModel {
    basePath = `${process.env.REACT_APP_HOST_URL}/auth`;
    headers = {
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-Client': UD_X_CLIENT
    }

    protected get serviceId() {
        return "Auth";
    }
}